import * as React from "react";
const SvgDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#2D2D2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.11}
      d="m15.305 10.696-.917 2.291a3.69 3.69 0 0 1-3.424 2.318H4.895a3.69 3.69 0 0 1-3.424-2.318l-.916-2.291m3.66-2.535 3.688 3.457m0 0L11.59 8.16m-3.687 3.457V.555"
    />
  </svg>
);
export default SvgDownload;
